"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_konva_1 = require("react-konva");
var piexifjs_1 = require("piexifjs");
var changedpi_1 = require("changedpi");
var ArtworkImage_1 = __importDefault(require("./ArtworkImage"));
var MaskImage_1 = __importDefault(require("./MaskImage"));
var InteractiveLayer_1 = __importDefault(require("./InteractiveLayer"));
var GenericTransformer_1 = __importDefault(require("./GenericTransformer"));
var MatBoardImage_1 = __importDefault(require("./MatBoardImage"));
var CustomText_1 = require("../CustomText");
var Signature_1 = __importDefault(require("../Signature"));
var helpers_1 = require("./helpers");
var helpers_2 = require("../../helpers");
var initialArtworkProps = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    scaleX: 1,
    scaleY: 1,
    rotation: 0
};
var ImagePreview = React.forwardRef(function (props, ref) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var artworkUrl = props.artworkUrl, maskUrl = props.maskUrl, _o = props.scalePercent, scalePercent = _o === void 0 ? 10 : _o, matboardUrl = props.matboardUrl, displayWithoutArtwork = props.displayWithoutArtwork, _p = props.rotation, rotation = _p === void 0 ? 0 : _p, productDims = props.productDims, stretchDims = props.stretchDims, isPreview = props.isPreview, 
    // hideFrame: hideFrameProps = false,
    // hideMatboard,
    canvasTexts = props.canvasTexts, signature = props.signature, 
    // selectedPanel,
    onScaling = props.onScaling, onSelectedText = props.onSelectedText, onChangeText = props.onChangeText, _q = props.isDisabledArtTransform, isDisabledArtTransform = _q === void 0 ? false : _q, _r = props.isDisabledAllTransform, isDisabledAllTransform = _r === void 0 ? false : _r, _s = props.artworkRotation, artworkRotation = _s === void 0 ? 0 : _s, onResolutionWarning = props.onResolutionWarning, onPositionText = props.onPositionText, onCanvasTexts = props.onCanvasTexts, onSignature = props.onSignature, _t = props.outerArtworkProps, outerArtworkProps = _t === void 0 ? initialArtworkProps : _t, onDPI = props.onDPI, _u = props.paddings, paddings = _u === void 0 ? { x: 0, y: 0 } : _u, _v = props.isCanvass, isCanvass = _v === void 0 ? false : _v, _w = props.isMaskOnFrame
    // onHideFrame
    , isMaskOnFrame = _w === void 0 ? false : _w
    // onHideFrame
    ;
    var _x = React.useState(outerArtworkProps), artworkProps = _x[0], setArtworkProps = _x[1];
    // const [hideFrame, setHideFrame] = React.useState(false);
    // const [hideOutline, setHideOutline] = React.useState(hideFrameProps)
    // console.log('top artworkProps', artworkProps);
    var containerRef = React.useRef(null);
    var interactiveLayerRef = React.useRef();
    var outlineRef = React.useRef();
    var frameRef = React.useRef(null);
    var matRef = React.useRef(null);
    var signTrRef = React.useRef(null);
    var transformerRef = React.useRef();
    var _y = React.useState({
        width: 500,
        height: 500
    }), containerDims = _y[0], setContainerDims = _y[1];
    var _z = React.useState({ width: 0, height: 0 }), frameMax = _z[0], setFrameMax = _z[1];
    // const [printableMax, setPrintableMax] = React.useState({
    //   width: 0,
    //   height: 0
    // });
    var _0 = React.useState(1), frameScale = _0[0], setFrameScale = _0[1];
    var _1 = React.useState({
        width: 0,
        height: 0
    }), nativeFramsDims = _1[0], setNativeFrameDims = _1[1];
    var _2 = React.useState({ x: 0, y: 0 }), frameCoords = _2[0], setFrameCoords = _2[1];
    var _3 = React.useState(false), isLoadingArtwork = _3[0], setIsLoadingArtwork = _3[1];
    var _4 = React.useState(false), isLoadingMask = _4[0], setIsLoadingMask = _4[1];
    // const [isLoadingMatboard, setIsLoadingMatboard] = React.useState(false)
    var isRotated = rotation % 180 !== 0;
    // console.log("rotation", rotation);
    var _5 = React.useState(false), isSignatureImageSelected = _5[0], setIsSignatureImageSelected = _5[1];
    var frameM = helpers_1.rotationDims(frameMax, rotation);
    var _6 = helpers_1.checkResolution(productDims, frameM, artworkProps, rotation), hasResolutionWarning = _6.hasResolutionWarning, checkInfo = __rest(_6, ["hasResolutionWarning"]);
    var hasStretchDims = !!(stretchDims === null || stretchDims === void 0 ? void 0 : stretchDims.width) && !!(stretchDims === null || stretchDims === void 0 ? void 0 : stretchDims.height);
    var updateContainerSize = function () {
        var _a, _b, _c;
        var containerRect = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        var containerWidth = (_b = containerRect === null || containerRect === void 0 ? void 0 : containerRect.width) !== null && _b !== void 0 ? _b : 0;
        var containerHeight = (_c = containerRect === null || containerRect === void 0 ? void 0 : containerRect.height) !== null && _c !== void 0 ? _c : 0;
        if (containerRect && containerHeight > 0) {
            setContainerDims({ width: containerWidth, height: containerHeight });
            setFrameCoords({
                x: containerWidth / 2,
                y: containerHeight / 2
            });
        }
    };
    var printableMax = {
        width: (paddings === null || paddings === void 0 ? void 0 : paddings.x) ? frameM.width * (paddings === null || paddings === void 0 ? void 0 : paddings.x) : frameM.width,
        height: (paddings === null || paddings === void 0 ? void 0 : paddings.y) ? frameM.height * (paddings === null || paddings === void 0 ? void 0 : paddings.y) : frameM.height
    };
    // console.log("containerDims top", containerDims);
    // console.log("printableMax top", printableMax);
    // console.log("paddings", paddings);
    // console.log("frameM top", frameM);
    // console.log("frameCoords top", frameCoords);
    var isFloatMount = (matboardUrl === null || matboardUrl === void 0 ? void 0 : matboardUrl.search("float-mount")) > -1 ||
        (matboardUrl === null || matboardUrl === void 0 ? void 0 : matboardUrl.search("stretched")) > -1;
    if (printableMax.width > containerDims.width) {
        var ratio = containerDims.width / printableMax.width;
        printableMax.width = containerDims.width;
        printableMax.height = printableMax.height * ratio;
    }
    else if (printableMax.height > containerDims.height) {
        var ratio = containerDims.height / printableMax.height;
        printableMax.height = containerDims.height;
        printableMax.width = printableMax.width * ratio;
    }
    // console.log("hasStretchDims", hasStretchDims);
    // const stretchWidth = productDims?.width / (stretchDims?.width as number);
    // const stretchHeight = productDims?.height / (stretchDims?.height as number);
    var stretchWidth = hasStretchDims
        ? ((stretchDims === null || stretchDims === void 0 ? void 0 : stretchDims.width) || 1) / (productDims === null || productDims === void 0 ? void 0 : productDims.width)
        : 1;
    var stretchHeight = hasStretchDims
        ? ((stretchDims === null || stretchDims === void 0 ? void 0 : stretchDims.height) || 1) / (productDims === null || productDims === void 0 ? void 0 : productDims.height)
        : 1;
    var redDashLine = {
        width: isFloatMount ? frameM.width * stretchWidth : printableMax.width,
        height: isFloatMount
            ? frameM.height * stretchHeight
            : // ? printableMax.height / (stretchHeight || 1) - 4
                printableMax.height
    };
    // console.log({
    //   isFloatMount,
    //   frameM,
    //   printableMax,
    //   redDashLine
    // });
    React.useImperativeHandle(ref, function () { return ({
        export: function (type) {
            var _a;
            (_a = outlineRef === null || outlineRef === void 0 ? void 0 : outlineRef.current) === null || _a === void 0 ? void 0 : _a.hide();
            return handleExport(type);
        },
        ctx: function () { return ({
            canvasTexts: canvasTexts,
            signature: signature,
            artworkProps: artworkProps,
            frameProps: __assign(__assign({}, frameM), { x: frameCoords.x - frameM.width / 2, y: frameCoords.y - frameM.height / 2 }),
            containerDims: {
                width: containerDims.width,
                height: containerDims.height
            }
        }); },
        handleHideFrame: function (value) {
            var _a, _b, _c, _d, _e, _f;
            (_a = frameRef === null || frameRef === void 0 ? void 0 : frameRef.current) === null || _a === void 0 ? void 0 : _a.show();
            (_b = matRef === null || matRef === void 0 ? void 0 : matRef.current) === null || _b === void 0 ? void 0 : _b.show();
            (_c = outlineRef === null || outlineRef === void 0 ? void 0 : outlineRef.current) === null || _c === void 0 ? void 0 : _c.hide();
            if (value) {
                (_d = outlineRef === null || outlineRef === void 0 ? void 0 : outlineRef.current) === null || _d === void 0 ? void 0 : _d.show();
                (_e = frameRef === null || frameRef === void 0 ? void 0 : frameRef.current) === null || _e === void 0 ? void 0 : _e.hide();
                (_f = matRef === null || matRef === void 0 ? void 0 : matRef.current) === null || _f === void 0 ? void 0 : _f.hide();
            }
        },
        checkForResolution: function () {
            var _a, _b, _c, _d;
            var lowestDPI = ((_a = checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.actualDPI) === null || _a === void 0 ? void 0 : _a.width) < ((_b = checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.actualDPI) === null || _b === void 0 ? void 0 : _b.height)
                ? (_c = checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.actualDPI) === null || _c === void 0 ? void 0 : _c.width : (_d = checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.actualDPI) === null || _d === void 0 ? void 0 : _d.height;
            return lowestDPI;
        }
    }); });
    React.useEffect(function () {
        var _a, _b, _c, _d, _e, _f;
        window.addEventListener("resize", updateContainerSize);
        updateContainerSize();
        if (isPreview) {
            (_a = outlineRef === null || outlineRef === void 0 ? void 0 : outlineRef.current) === null || _a === void 0 ? void 0 : _a.hide();
            (_b = frameRef === null || frameRef === void 0 ? void 0 : frameRef.current) === null || _b === void 0 ? void 0 : _b.show();
            (_c = matRef === null || matRef === void 0 ? void 0 : matRef.current) === null || _c === void 0 ? void 0 : _c.show();
        }
        else {
            setArtworkSelected(true);
            (_d = outlineRef === null || outlineRef === void 0 ? void 0 : outlineRef.current) === null || _d === void 0 ? void 0 : _d.show();
            (_e = frameRef === null || frameRef === void 0 ? void 0 : frameRef.current) === null || _e === void 0 ? void 0 : _e.hide();
            (_f = matRef === null || matRef === void 0 ? void 0 : matRef.current) === null || _f === void 0 ? void 0 : _f.hide();
        }
        return function () {
            window.removeEventListener("resize", updateContainerSize);
        };
    }, []);
    React.useEffect(function () {
        var _a, _b, _c, _d;
        var lowestDPI = ((_a = checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.actualDPI) === null || _a === void 0 ? void 0 : _a.width) < ((_b = checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.actualDPI) === null || _b === void 0 ? void 0 : _b.height)
            ? (_c = checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.actualDPI) === null || _c === void 0 ? void 0 : _c.width : (_d = checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.actualDPI) === null || _d === void 0 ? void 0 : _d.height;
        onDPI === null || onDPI === void 0 ? void 0 : onDPI(lowestDPI);
    }, [hasResolutionWarning, checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.actualDPI]);
    React.useEffect(function () {
        var offsetX = -(artworkProps.width * artworkProps.scaleX) / 2;
        var offsetY = -(artworkProps.height * artworkProps.scaleY) / 2;
        var topLeft = { x1: offsetX, y1: offsetY };
        var current = helpers_1.rotatingPoint(topLeft, artworkProps.rotation);
        var rotated = helpers_1.rotatingPoint(topLeft, artworkRotation);
        var dx = rotated.x - current.x;
        var dy = rotated.y - current.y;
        if (artworkProps.width && artworkProps.height) {
            setArtworkProps(__assign(__assign({}, artworkProps), { rotation: artworkRotation, x: artworkProps.x + dx, y: artworkProps.y + dy }));
        }
    }, [artworkRotation]);
    React.useEffect(function () {
        var _a, _b;
        var scaleX = (_a = outerArtworkProps === null || outerArtworkProps === void 0 ? void 0 : outerArtworkProps.scaleX) !== null && _a !== void 0 ? _a : 1;
        var scaleY = (_b = outerArtworkProps === null || outerArtworkProps === void 0 ? void 0 : outerArtworkProps.scaleY) !== null && _b !== void 0 ? _b : 1;
        var calcArtworkMax = {
            scaleX: (scaleX * scalePercent) / 100,
            scaleY: (scaleY * scalePercent) / 100
        };
        if (artworkProps.width && artworkProps.height) {
            setArtworkProps(__assign(__assign({}, artworkProps), calcArtworkMax));
        }
    }, [scalePercent]);
    React.useEffect(function () {
        updateContainerSize();
        if (outerArtworkProps.width && outerArtworkProps.height) {
            setArtworkProps(outerArtworkProps);
        }
        else {
            onArtworkLoad({
                width: artworkProps.width,
                height: artworkProps.height
            });
        }
    }, [frameMax, rotation]);
    React.useEffect(function () {
        onArtworkLoad({
            width: artworkProps.width,
            height: artworkProps.height
        });
    }, [paddings.x, paddings.y]);
    React.useEffect(function () {
        updateContainerSize();
        onMaskLoad(nativeFramsDims);
    }, [rotation]);
    React.useEffect(function () {
        if (outerArtworkProps.width && outerArtworkProps.height) {
            onScaling === null || onScaling === void 0 ? void 0 : onScaling(100);
            setArtworkProps(outerArtworkProps);
        }
    }, [outerArtworkProps]);
    React.useEffect(function () {
        if (!maskUrl) {
            // frameRef.current?.hide();
            onMaskLoad({
                width: (isRotated ? productDims.height : productDims.width) * 37.7952755906,
                height: (isRotated ? productDims.width : productDims.height) * 37.7952755906 // convert px to cm
            });
        }
        else {
            // frameRef.current?.show();
        }
    }, [productDims.width, productDims.height, maskUrl]);
    var onArtworkLoad = function (v) {
        if (!frameMax.height) {
            setArtworkProps(__assign({}, v));
        }
        if (isFloatMount) {
            frameM = helpers_1.rotationDims({
                width: frameMax.width,
                height: frameMax.height
            }, rotation);
        }
        if (!(v === null || v === void 0 ? void 0 : v.width) || !(v === null || v === void 0 ? void 0 : v.height)) {
            setArtworkProps(artworkProps);
            return;
        }
        // const framePadded = {
        //   width: paddings?.x ? frameM.width * paddings?.x : frameM.width,
        //   height: paddings?.y ? frameM.height * paddings?.y : frameM.height
        // };
        // console.log("framePadded", framePadded);
        // setPrintableMax(framePadded);
        var dims = isFloatMount ? redDashLine : printableMax;
        // console.log("dims", dims);
        var best = helpers_1.bestFitArtwork(dims, v);
        // const roundedScale = Math.round(best.scale);
        var roundedScale = Math.round((1 / best.scale) * 100);
        roundedScale && (onScaling === null || onScaling === void 0 ? void 0 : onScaling(roundedScale));
        var artwork = __assign(__assign({}, v), { rotation: artworkRotation, scaleX: 1 / best.scale, scaleY: 1 / best.scale, 
            // scaleX: 1 / (best.scale ?? 1),
            // scaleY: 1 / (best.scale ?? 1),
            x: containerDims.width / 2, 
            // x: (containerDims.width - best.width) / 2,
            y: containerDims.height / 2 });
        setArtworkProps(artwork);
    };
    var onMaskLoad = function (v) {
        setNativeFrameDims(v);
        var rotationAwareDims = helpers_1.rotationDims(v, rotation);
        var best = helpers_1.bestFit(containerDims, rotationAwareDims);
        // console.log("best", best);
        var calcFrameMax = {
            width: isRotated ? best.height : best.width,
            height: isRotated ? best.width : best.height // * padding,
        };
        // setStageDims(frameMax)
        setFrameScale(best.scale);
        setFrameMax(calcFrameMax);
        setFrameCoords({
            x: containerDims.width / 2,
            y: containerDims.height / 2
        });
    };
    var stageRef = React.useRef(null);
    var checkDeselect = function (e) {
        var clickedOnEmpty = e.target.attrs.className === "boundary";
        if (clickedOnEmpty) {
            setArtworkSelected(false);
            setIsSignatureImageSelected(false);
            onSelectedText === null || onSelectedText === void 0 ? void 0 : onSelectedText(null);
            var updatedCanvas = canvasTexts === null || canvasTexts === void 0 ? void 0 : canvasTexts.map(function (c) { return (__assign(__assign({}, c), { isActive: false })); });
            onCanvasTexts === null || onCanvasTexts === void 0 ? void 0 : onCanvasTexts(updatedCanvas);
        }
    };
    var _7 = React.useState(false), isArtworkSelected = _7[0], setArtworkSelected = _7[1];
    var handleExport = function (type) {
        if (type === void 0) { type = "artwork"; }
        return __awaiter(void 0, void 0, void 0, function () {
            var updatedCanvas, artworkScaleX, artworkScaleY, artworkScale, prodWidthToPx, prodHeightToPx, width, height, downloadScale, pixelRatio, options, uri, insertedData, zeroth, exifObj, exifStr, blob;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            return __generator(this, function (_m) {
                switch (_m.label) {
                    case 0:
                        setArtworkSelected(false);
                        updatedCanvas = canvasTexts === null || canvasTexts === void 0 ? void 0 : canvasTexts.map(function (c) { return (__assign(__assign({}, c), { isActive: false })); });
                        onCanvasTexts === null || onCanvasTexts === void 0 ? void 0 : onCanvasTexts(updatedCanvas);
                        setIsSignatureImageSelected(false);
                        (_a = interactiveLayerRef === null || interactiveLayerRef === void 0 ? void 0 : interactiveLayerRef.current) === null || _a === void 0 ? void 0 : _a.hide();
                        (_b = outlineRef === null || outlineRef === void 0 ? void 0 : outlineRef.current) === null || _b === void 0 ? void 0 : _b.hide();
                        (_c = signTrRef === null || signTrRef === void 0 ? void 0 : signTrRef.current) === null || _c === void 0 ? void 0 : _c.hide();
                        (_d = transformerRef === null || transformerRef === void 0 ? void 0 : transformerRef.current) === null || _d === void 0 ? void 0 : _d.hide();
                        (_e = frameRef === null || frameRef === void 0 ? void 0 : frameRef.current) === null || _e === void 0 ? void 0 : _e.show();
                        (_f = matRef === null || matRef === void 0 ? void 0 : matRef.current) === null || _f === void 0 ? void 0 : _f.show();
                        if (type === "artwork") {
                            (_g = frameRef === null || frameRef === void 0 ? void 0 : frameRef.current) === null || _g === void 0 ? void 0 : _g.hide();
                            (_h = matRef === null || matRef === void 0 ? void 0 : matRef.current) === null || _h === void 0 ? void 0 : _h.hide();
                            onResolutionWarning === null || onResolutionWarning === void 0 ? void 0 : onResolutionWarning(hasResolutionWarning);
                        }
                        artworkScaleX = ((productDims.width / 2.54) * 150) / printableMax.width;
                        artworkScaleY = ((productDims.height / 2.54) * 150) / printableMax.height;
                        artworkScale = Math.max(artworkScaleX, artworkScaleY);
                        prodWidthToPx = ((productDims.width / 2.54) * 150) / artworkScale;
                        prodHeightToPx = ((productDims.height / 2.54) * 150) / artworkScale;
                        width = type !== "artwork" ? frameM.width : prodWidthToPx;
                        height = type !== "artwork" ? frameM.height : prodHeightToPx;
                        downloadScale = (isRotated ? 1500 : 1000) / width;
                        pixelRatio = artworkScale;
                        if (type === "thumb") {
                            pixelRatio = 1;
                        }
                        else if (type === "download") {
                            pixelRatio = downloadScale;
                        }
                        options = {
                            mimeType: "image/jpeg",
                            quality: 1,
                            pixelRatio: pixelRatio,
                            width: width,
                            height: height,
                            x: frameCoords.x - width / 2,
                            y: frameCoords.y - height / 2
                        };
                        return [4 /*yield*/, stageRef.current.toDataURL(options)];
                    case 1:
                        uri = _m.sent();
                        insertedData = "";
                        if (type === "artwork") {
                            zeroth = {};
                            zeroth[piexifjs_1.piexif.ImageIFD.XResolution] = [150, 1];
                            zeroth[piexifjs_1.piexif.ImageIFD.YResolution] = [150, 1];
                            exifObj = piexifjs_1.piexif.load(uri);
                            exifStr = piexifjs_1.piexif.dump(__assign(__assign({}, exifObj), { "0th": zeroth }));
                            insertedData = changedpi_1.changeDpiDataUrl(uri, 150);
                            insertedData = piexifjs_1.piexif.insert(exifStr, insertedData);
                        }
                        blob = helpers_2.dataURItoBlob(type === "artwork" ? insertedData : uri);
                        (_j = interactiveLayerRef === null || interactiveLayerRef === void 0 ? void 0 : interactiveLayerRef.current) === null || _j === void 0 ? void 0 : _j.show();
                        // outlineRef?.current?.show();
                        (_k = frameRef === null || frameRef === void 0 ? void 0 : frameRef.current) === null || _k === void 0 ? void 0 : _k.show();
                        (_l = matRef === null || matRef === void 0 ? void 0 : matRef.current) === null || _l === void 0 ? void 0 : _l.show();
                        // onHideFrame(false)
                        // setHideOutline(false)
                        return [2 /*return*/, blob];
                }
            });
        });
    };
    var handleDeleteText = function (idx) {
        var updatedCanvas = canvasTexts === null || canvasTexts === void 0 ? void 0 : canvasTexts.filter(function (c, index) { return index !== idx; });
        onCanvasTexts === null || onCanvasTexts === void 0 ? void 0 : onCanvasTexts(updatedCanvas);
    };
    // console.log({
    //   artworkProps,
    //   frameM,
    //   frameMax,
    //   printableMax,
    //   maskUrl,
    //   matboardUrl,
    //   paddings
    // });
    // console.log("artworkProps", artworkProps);
    // console.log("outlineRef", outlineRef?.current?.visible());
    // If there is no artwork url, we still want to show the frame and matboard.
    var isStillLoading = (isLoadingArtwork || (isLoadingMask && !!maskUrl)) &&
        !displayWithoutArtwork;
    var xHeightBoundary = (containerDims.height - (isRotated ? frameMax.width : frameMax.height)) / 2;
    var mm = 5 * (96 / 25.4);
    var signatureBoundary = {
        width: isFloatMount ? printableMax.width : printableMax.width - mm,
        height: isFloatMount ? printableMax.height : printableMax.height - mm,
        x: frameCoords.x -
            (isFloatMount ? printableMax.width : printableMax.width - mm) / 2,
        y: frameCoords.y -
            (isFloatMount ? printableMax.height : printableMax.height - mm) / 2
    };
    // console.log({ frameMax, redDashLine, artworkProps, frameM });
    return (React.createElement("div", null,
        hasStretchDims && isCanvass && (React.createElement("p", { style: {
                margin: ".5em auto",
                textAlign: "center",
                visibility: ((_a = outlineRef === null || outlineRef === void 0 ? void 0 : outlineRef.current) === null || _a === void 0 ? void 0 : _a.visible()) ? "visible" : "hidden"
            } },
            " ",
            "Mirrored bleed will automatically be applied")),
        React.createElement("div", { ref: containerRef, style: { backgroundColor: "white", minHeight: 400 } },
            React.createElement(react_konva_1.Stage, { onMouseDown: checkDeselect, onTouchStart: checkDeselect, onContextMenu: function (e) {
                    e.evt.preventDefault();
                }, ref: stageRef, width: containerDims.width, height: containerDims.height },
                React.createElement(react_konva_1.Layer, { visible: isStillLoading, draggable: false },
                    React.createElement(react_konva_1.Text, { wrap: "char", align: "center", verticalAlign: "middle", width: containerDims.width, text: "Loading..." })),
                React.createElement(react_konva_1.Layer, null,
                    React.createElement(react_konva_1.Rect, { width: frameM.width, height: frameM.height, x: frameCoords.x - frameM.width / 2, y: frameCoords.y - frameM.height / 2, fill: "white" })),
                isFloatMount && (React.createElement(React.Fragment, null,
                    React.createElement(react_konva_1.Layer, null,
                        React.createElement(react_konva_1.Group, { visible: !isStillLoading, draggable: false },
                            isCanvass && (React.createElement(react_konva_1.Rect, { width: frameM.width, height: frameM.height, x: frameCoords.x - frameM.width / 2, y: frameCoords.y - frameM.height / 2, fill: "#9b9b9b", visible: (_b = outlineRef === null || outlineRef === void 0 ? void 0 : outlineRef.current) === null || _b === void 0 ? void 0 : _b.visible() })),
                            React.createElement(react_konva_1.Text, { y: 10, wrap: "char", align: "center", verticalAlign: "middle", width: containerDims.width, text: "", visible: (_c = outlineRef === null || outlineRef === void 0 ? void 0 : outlineRef.current) === null || _c === void 0 ? void 0 : _c.visible() }),
                            React.createElement(MatBoardImage_1.default, __assign({ width: frameMax.width, height: frameMax.height }, frameCoords, { imageUrl: matboardUrl, rotation: rotation, ref: matRef, visible: (_d = matRef === null || matRef === void 0 ? void 0 : matRef.current) === null || _d === void 0 ? void 0 : _d.visible(), onImageLoad: onMaskLoad })))),
                    React.createElement(react_konva_1.Layer, null,
                        React.createElement(react_konva_1.Group, null,
                            React.createElement(react_konva_1.Group, null,
                                React.createElement(ArtworkImage_1.default, { artworkProps: artworkProps, onImageLoad: function (v) { return onArtworkLoad(v); }, imageUrl: artworkUrl, productDims: productDims, onLoad: function (v) { return setIsLoadingArtwork(v); }, visible: isFloatMount, onSelect: function () {
                                        setArtworkSelected(true);
                                        setIsSignatureImageSelected(false);
                                    } }),
                                React.createElement(react_konva_1.Group, { globalCompositeOperation: "destination-in", visible: isFloatMount },
                                    React.createElement(react_konva_1.Rect, { fill: "white", width: redDashLine.width, height: redDashLine.height, x: frameCoords.x - redDashLine.width / 2, y: frameCoords.y - redDashLine.height / 2 }))),
                            React.createElement(MaskImage_1.default, __assign({ width: frameMax.width, height: frameMax.height }, frameCoords, { imageUrl: maskUrl, ref: frameRef, rotation: rotation, visible: (_e = frameRef === null || frameRef === void 0 ? void 0 : frameRef.current) === null || _e === void 0 ? void 0 : _e.visible(), onImageLoad: onMaskLoad, onLoad: function (v) { return setIsLoadingMask(v); } })),
                            React.createElement(react_konva_1.Rect, { width: redDashLine.width, height: redDashLine.height, x: frameCoords.x - redDashLine.width / 2, y: frameCoords.y - redDashLine.height / 2, strokeEnabled: true, strokeheight: 2, stroke: "red", dashEnabled: true, dash: [5, 5], ref: outlineRef, visible: (_f = outlineRef === null || outlineRef === void 0 ? void 0 : outlineRef.current) === null || _f === void 0 ? void 0 : _f.visible() }))))),
                !isFloatMount && (React.createElement(react_konva_1.Layer, { visible: true, draggable: false },
                    React.createElement(react_konva_1.Group, { visible: !isStillLoading, draggable: false, globalCompositeOperation: "source-over" },
                        React.createElement(ArtworkImage_1.default, { artworkProps: artworkProps, onImageLoad: function (v) { return onArtworkLoad(v); }, imageUrl: artworkUrl, productDims: productDims, onLoad: function (v) { return setIsLoadingArtwork(v); }, visible: !isFloatMount, onSelect: function () {
                                setArtworkSelected(true);
                                setIsSignatureImageSelected(false);
                            } }),
                        React.createElement(react_konva_1.Rect, { width: redDashLine.width, height: redDashLine.height, x: frameCoords.x - redDashLine.width / 2, y: frameCoords.y - redDashLine.height / 2, strokeEnabled: true, strokeheight: 2, stroke: "red", dashEnabled: true, dash: [5, 5], ref: outlineRef, visible: (_g = outlineRef === null || outlineRef === void 0 ? void 0 : outlineRef.current) === null || _g === void 0 ? void 0 : _g.visible() }),
                        React.createElement(react_konva_1.Group, { globalCompositeOperation: "destination-in", visible: isMaskOnFrame },
                            React.createElement(react_konva_1.Rect, { fill: "white", width: printableMax.width, height: printableMax.height, x: frameCoords.x - printableMax.width / 2, y: frameCoords.y - printableMax.height / 2 })),
                        React.createElement(MatBoardImage_1.default, __assign({ width: frameMax.width, height: frameMax.height }, frameCoords, { imageUrl: matboardUrl, rotation: rotation, ref: matRef, visible: (_h = matRef === null || matRef === void 0 ? void 0 : matRef.current) === null || _h === void 0 ? void 0 : _h.visible(), onImageLoad: onMaskLoad })),
                        React.createElement(ArtworkImage_1.default, { artworkProps: artworkProps, onImageLoad: function (v) { return onArtworkLoad(v); }, imageUrl: artworkUrl, productDims: productDims, onLoad: function (v) { return setIsLoadingArtwork(v); }, visible: isFloatMount, onSelect: function () {
                                setArtworkSelected(true);
                                setIsSignatureImageSelected(false);
                            } }),
                        React.createElement(react_konva_1.Rect, { width: redDashLine.width, height: redDashLine.height, x: frameCoords.x - redDashLine.width / 2, y: frameCoords.y - redDashLine.height / 2, strokeEnabled: true, strokeheight: 2, stroke: "red", dashEnabled: true, dash: [5, 5], ref: outlineRef, visible: (_j = outlineRef === null || outlineRef === void 0 ? void 0 : outlineRef.current) === null || _j === void 0 ? void 0 : _j.visible() }),
                        React.createElement(react_konva_1.Group, { globalCompositeOperation: "destination-in", visible: isFloatMount },
                            React.createElement(react_konva_1.Rect, { width: frameM.width, height: frameM.height, x: frameCoords.x - frameM.width / 2, y: frameCoords.y - frameM.height / 2, fill: "white" })),
                        React.createElement(MaskImage_1.default, __assign({ width: frameMax.width, height: frameMax.height }, frameCoords, { imageUrl: maskUrl, ref: frameRef, rotation: rotation, visible: (_k = frameRef === null || frameRef === void 0 ? void 0 : frameRef.current) === null || _k === void 0 ? void 0 : _k.visible(), onImageLoad: onMaskLoad, onLoad: function (v) { return setIsLoadingMask(v); } }))))),
                React.createElement(react_konva_1.Layer, null,
                    React.createElement(react_konva_1.Group, null,
                        React.createElement(react_konva_1.Rect, { id: "top-boundary", className: "boundary", width: containerDims.width, height: xHeightBoundary, x: 0, y: 0, fill: "white" }),
                        React.createElement(react_konva_1.Rect, { id: "left-boundary", className: "boundary", width: frameCoords.x - frameM.width / 2, height: containerDims.height, x: 0, y: 0, fill: "white" }),
                        React.createElement(react_konva_1.Rect, { id: "right-boundary", className: "boundary", width: frameM.width, height: containerDims.height, x: frameCoords.x + frameM.width / 2, y: 0, fill: "white" }),
                        React.createElement(react_konva_1.Rect, { id: "bottom-boundary", className: "boundary", width: containerDims.width, height: xHeightBoundary, x: 0, y: containerDims.height - xHeightBoundary, scaleX: 100, scaleY: 100, fill: "white" }))),
                React.createElement(react_konva_1.Layer, null,
                    React.createElement(react_konva_1.Group, { visible: true }, canvasTexts === null || canvasTexts === void 0 ? void 0 :
                        canvasTexts.map(function (t, index) { return (React.createElement(CustomText_1.CustomText, { key: index, textProps: {
                                text: t.text,
                                fill: t.fill,
                                fontSize: t.fontSize,
                                fontFamily: t.fontFamily,
                                x: t.x,
                                y: t.y,
                                index: index
                            }, isTransformDisabled: isDisabledAllTransform, isSelected: t.isActive, onSelect: function () { return onSelectedText === null || onSelectedText === void 0 ? void 0 : onSelectedText(index); }, onChange: onChangeText, onPositionText: onPositionText, onDelete: function () { return handleDeleteText(index); } })); }),
                        React.createElement(Signature_1.default, { isTransformDisabled: isDisabledAllTransform, signatureProps: __assign(__assign({}, signature), { x: (signature === null || signature === void 0 ? void 0 : signature.x) || frameCoords.x, y: (signature === null || signature === void 0 ? void 0 : signature.y) || frameCoords.y }), imageUrl: (_l = signature === null || signature === void 0 ? void 0 : signature.image) !== null && _l !== void 0 ? _l : "", ref: signTrRef, isSelected: isSignatureImageSelected, onSelect: function () {
                                setArtworkSelected(false);
                                setIsSignatureImageSelected(true);
                            }, onChange: function (v) { return onSignature === null || onSignature === void 0 ? void 0 : onSignature(v); }, onDelete: function () {
                                onSignature === null || onSignature === void 0 ? void 0 : onSignature({});
                                setIsSignatureImageSelected(false);
                            } }),
                        React.createElement(react_konva_1.Group, { globalCompositeOperation: "destination-in" },
                            React.createElement(react_konva_1.Rect, { width: signatureBoundary.width, height: signatureBoundary.height, x: signatureBoundary.x, y: signatureBoundary.y, fill: "white" })))),
                (!isDisabledArtTransform || !isDisabledAllTransform) && (React.createElement(InteractiveLayer_1.default, { interactiveLayerRef: interactiveLayerRef, artworkProps: artworkProps, isSelected: isArtworkSelected, setArtworkProps: setArtworkProps, onSelect: function () {
                        setArtworkSelected(true);
                        setIsSignatureImageSelected(false);
                    } })),
                (!isDisabledArtTransform || !isDisabledAllTransform) && (React.createElement(GenericTransformer_1.default
                // interactiveSignLayerRef={interactiveSignLayerRef}
                , { 
                    // interactiveSignLayerRef={interactiveSignLayerRef}
                    ref: signTrRef, componentProps: __assign(__assign({}, signature), { x: (signature === null || signature === void 0 ? void 0 : signature.x) || frameCoords.x, y: (signature === null || signature === void 0 ? void 0 : signature.y) || frameCoords.y }), imageUrl: (_m = signature === null || signature === void 0 ? void 0 : signature.image) !== null && _m !== void 0 ? _m : "", isSelected: isSignatureImageSelected, onChange: function (v) { return onSignature === null || onSignature === void 0 ? void 0 : onSignature(v); }, onSelect: function () {
                        setArtworkSelected(false);
                        setIsSignatureImageSelected(true);
                    } }))))));
});
exports.default = ImagePreview;
